import React, { useContext, useEffect, useRef, useState } from "react";
import { AppContextProvider } from "../App.js";
import { CiSearch } from "react-icons/ci";
import { HiOutlineMenuAlt4 } from "react-icons/hi";
import { AcMobileDropDown } from "./AccountSettings/AcMobileDropDown.jsx";
import searchResult from "../Data/SearchData.js";
import { IoTimeOutline } from "react-icons/io5";
import MobileMenu from "./MobileUl/MobileMenu.jsx";
import { MobileInputfield } from "./MobileInputfield.jsx";
import Logo from "../assets/Logo.svg";
import { IoBagOutline } from "react-icons/io5";
import { Cart } from "./Cart/Cart.jsx";
import { IoClose } from "react-icons/io5";
import { FaBell } from "react-icons/fa";
import { FiBell } from "react-icons/fi";
import mobileDark from "../assets/HomeIcons/mobile.png";
import dashboardDark from "../assets/HomeIcons/Dashboard.png";
import themesDark from "../assets/HomeIcons/Template (1).png";
import fontDark from "../assets/HomeIcons/Fonts.png";
import giftDark from "../assets/HomeIcons/Freebies.png";
import mobileLight from "../assets/HomeIcons/IconsWhite/Mobile-phone (1).png";
import dashboardLight from "../assets/HomeIcons/IconsWhite/Dashboard (1).png";
import themesLight from "../assets/HomeIcons/IconsWhite/Template (2).png";
import fontLight from "../assets/HomeIcons/IconsWhite/Fonts.png";
import giftLight from "../assets/HomeIcons/IconsWhite/Freebies.png";
import useOutsideClick from "../utils/useOutsideClick.jsx";
const Navbar = () => {
  const {
    showMobileAuthorMenu,
    showMobileMenu,
    handleShowMenu,
    showMobileMenuRef
  } = useContext(AppContextProvider);
  const [loggedUser, setLoggedUser] = useState(true);

  const [author, setAuthor] = useState(true);
  const [showMo, setShowHam] = useState(false);
  const [hideNav, setHideNav] = useState(false);
  const [showAllProducts, setShowAllProducts] = useState(false);
  const [darkLight, setDarkLight] = useState(
    () => localStorage.getItem("dark") === "true"
  );
  const [showSearchDropDown, setShowSearchDropDown] = useState(false);
  const [userSearch, setUserSearch] = useState("");
  const [dropDown, setDropDown] = useState(false);
  const [showAcSideBar, setShowAcSideBar] = useState(false);
  const [showCart, setShowCart] = useState(false);
 

  useEffect(() => {

    if (window.location.pathname === "/") {
      localStorage.setItem("currentLink", "flows");
    }
    if (window.location.pathname === "/Pages/Plans") {
      localStorage.setItem("currentLink", "pricing");
    }
    if (
      window.location.pathname === "/Pages/Registration" ||
      window.location.pathname === "/Pages/Reset" || window.location.pathname === "/Pages/CreateNewPassword"
    ) {
      setShowHam(false);
      setHideNav(true);
    } else {
      setShowHam(true);
      setHideNav(false);
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth > 1024) {
        setShowSearchDropDown(false);
      }
    });

  }, []);


  const allProductsRef = useOutsideClick(() => setShowAllProducts(false));
  const acSideBarRef = useOutsideClick(() => setShowAcSideBar(false));
  const showCartRef = useOutsideClick(() => setShowCart(false));

  const options = [
    {
      value: "UI Kits",
      label: (
        <div className="flex items-center space-x-1 ">
          <img
            src={darkLight ? mobileDark : mobileLight}
            className="mr-2 w-10 h-10 bg-[#F0F0F0] dark:bg-[#282828] p-[10px] rounded-lg"
            alt="mobile"
          />
          <div>
            <p className="text-[16px]">Mobile UI Kits</p>
            <p className="text-xs opacity-60">
              Build your next mobile app design
            </p>
          </div>
        </div>
      ),
    },
    {
      value: "Dashbords / Admin Panels",
      label: (
        <div className="flex items-center">
          <img
            src={darkLight ? dashboardDark : dashboardLight}
            className="mr-2 w-10 h-10 bg-[#F0F0F0] dark:bg-[#282828] p-[10px] rounded-lg"
            alt="dashboard"
          />
          <div>
            <p className="text-[16px]">Dashbords / Admin Panels</p>
            <p className="text-xs opacity-60">
              Build your next mobile app design
            </p>
          </div>
        </div>
      ),
    },
    {
      value: "Themes & Templates",
      label: (
        <div className="flex items-center">
          <img
            src={darkLight ? themesDark : themesLight}
            className="mr-2 w-10 h-10 bg-[#F0F0F0] dark:bg-[#282828] p-[10px] rounded-lg"
            alt="themes"
          />
          <div>
            <p className="text-[16px]">Themes & Templates</p>
            <p className="text-xs opacity-60">
              Build your next mobile app design
            </p>
          </div>
        </div>
      ),
    },
    {
      value: "Fonts",
      label: (
        <div className="flex items-center">
          <img
            src={darkLight ? fontDark : fontLight}
            className="mr-2 w-10 h-10 bg-[#F0F0F0] dark:bg-[#282828] p-[10px] rounded-lg"
            alt="font"
          />
          <div>
            <p className="text-[16px]">Fonts</p>
            <p className="text-xs opacity-60">
              Build your next mobile app design
            </p>
          </div>
        </div>
      ),
    },
    {
      value: "Freebies",
      label: (
        <div className="flex items-center">
          <img
            src={darkLight ? giftDark : giftLight}
            className="mr-2 w-10 h-10 bg-[#F0F0F0] dark:bg-[#282828] p-[10px] rounded-lg"
            alt="gift"
          />
          <div>
            <p className="text-[16px]">Freebies</p>
            <p className="text-xs opacity-60">
              Build your next mobile app design
            </p>
          </div>
        </div>
      ),
    },
    // Add more options here if needed
  ];

  const handleClearSearch = () => {
    setUserSearch("");
    setDropDown(false);
  };

  return (
    <>
      {showSearchDropDown ? (
        <div className="py-4 px-4 lg:hidden">
          {/* <----------------------- this is inputfield in smaller screen -----------------------> */}
          <MobileInputfield setShowSearchDropDown={setShowSearchDropDown} />
        </div>
      ) : (
        <div
          className={
            hideNav
              ? "hidden"
              : "flex justify-between items-center p-4 px-6 border-b dark:border-[#3d3d3d] border-gray-2"
          }
        >
          <div className="flex items-center space-x-2">
            {showMobileMenu || showMobileAuthorMenu ? (
              <div
                onClick={handleShowMenu}
                className=" px-2 py-.5 text-mdfont-bold  cursor-pointer lg:hidden"
              >
                <IoClose className="text-xl" />
              </div>
            ) : (
              <HiOutlineMenuAlt4
                onClick={handleShowMenu}
                className="lg:hidden cursor-pointer rounded p-1 text-3xl"
              />
            )}
            <a href="/">
              <img className="w-11 h-11" src={Logo} alt="" />
            </a>
          </div>

          {/* <----------------------- Search bar -----------------------> */}
          <div
            id="search_bar"
            className="relative hidden lg:flex space-x-2 items-center bg-[#F0F0F0] dark:bg-[#3D3D3D] dark:text-gray-300 rounded-lg px-2 py-2 w-2/5"
          >
            <CiSearch className="text-2xl dark:text-white" />
            <input
              onChange={(e) => {
                setUserSearch(e.target.value.toLowerCase());
                setDropDown(!dropDown);
              }}
              value={userSearch}
              className="bg-transparent w-full outline-none"
              type="text"
              placeholder="Search ux flows, categories or screens"
            />
            <div
              onClick={handleClearSearch}
              className={
                userSearch.length > 0 ? "block cursor-pointer" : "hidden"
              }
            >
              X
            </div>
            <div
              id="search_results"
              className={
                dropDown
                  ? "absolute top-12 -left-2 w-full mx-auto rounded-b-xl bg-white drop-shadow-lg h-auto p-4 z-[5000] dark:bg-[#232323]"
                  : "hidden"
              }
            >
              {searchResult
                .filter((a) => a.includes(userSearch))
                .map((result) => (
                  <div className="flex items-center space-x-2">
                    <IoTimeOutline />
                    <p className="py-1">{result}</p>
                  </div>
                ))}
            </div>
          </div>
          <div className="flex justify-between items-center space-x-4">
            <ul className="lg:flex items-center space-x-4 hidden ">
              <div className="relative ">
                <li
                  onClick={() => setShowAllProducts((prev) => !prev)}
                  className="cursor-pointer"
                >
                  All Products
                </li>
                {showAllProducts && (
                  <div  ref={allProductsRef} className="bg-white border-[1px] border-[#D3D3D3] dark:bg-[#1C1C1C]   w-[340px] absolute top-10 -left-64 md:-left-2 drop-select flex flex-col dark:border dark:border-[#5B5B5B] px-4  pb-3 rounded-xl text-xl z-10">
                    {options.map((option, index) => (
                      <div
                        key={option.value}
                        className={`py-3 text-2xl cursor-pointer ${
                          index !== options.length - 1
                            ? "border-b border-b-[#F0F0F0] dark:border-b-[#5B5B5B]"
                            : ""
                        }`}
                      >
                        {option.label}
                      </div>
                    ))}
                    <button className="bg-[#1C1C1C] text-white dark:bg-white dark:text-black rounded-lg px-5 py-2">
                      View All
                    </button>
                  </div>
                )}
              </div>
              {!author && <li>Become an Author</li>}
              {author && (
                <a
                  href="/Pages/authorDashboard"
                  className="bg-white text-black px-4 py-2 rounded-lg"
                >
                  Author Dashboard
                </a>
              )}
            </ul>
            {/* <ul className="lg:flex items-center space-x-4 hidden ">
              <li
                onClick={() => {
                  setCurrentLink("flows");
                  localStorage.setItem("currentLink", "flows");
                  setActiveNav(true);
                }}
                className={
                  localStorage.getItem("currentLink") === "flows"
                    ? "underline"
                    : "no-underline"
                }
              >
                <a href="/">UX Flows</a>
              </li>
              <li
                onClick={() => {
                  setCurrentLink("pricing");
                  localStorage.setItem("currentLink", "pricing");
                  setActiveNav(true);
                }}
                className={
                  localStorage.getItem("currentLink") === "pricing"
                    ? "underline"
                    : "no-underline"
                }
              >
                <a href="/Pages/Plans">Pricing</a>
              </li>
              <li
                onClick={() => {
                  setCurrentLink("faq");
                  localStorage.setItem("currentLink", "faq");
                  setActiveNav(true);
                }}
                className={
                  localStorage.getItem("currentLink") === "faq"
                    ? "underline"
                    : " no-underline"
                }
              >
                <a href="/Pages/FAQ">FAQ</a>
              </li>
            </ul> */}

            {/* <----------------------- toggle light and dark mode -----------------------> */}
            {/* <div
              id="darklight"
              className="lg:flex hidden h-6 border dark:border-gray-500 rounded-lg "
            >
              <FiSun
                onClick={() => handleThemeToggle("light")}
                className={`cursor-pointer w-1/2 h-full text-3xl px-3 py-1 ${
                  !darkLight
                    ? "border border-black dark:border-white rounded-lg"
                    : ""
                }`}
              />
              <FaRegMoon
                onClick={() => handleThemeToggle("dark")}
                className={`cursor-pointer w-1/2 h-full text-3xl px-3 py-1 ${
                  darkLight
                    ? "border border-black dark:border-white rounded-lg"
                    : ""
                }`}
              />
            </div> */}

            {/* <----------------------- join us button -----------------------> */}
            <div id="joinus" className="flex items-center space-x-4">
              {author && (
                <div className="relative">
                  <FiBell className="text-xl" />
                  <div className="bg-[#E85959] w-2 h-2 rounded-full absolute -top-0 -right-0" />
                </div>
              )}
              <CiSearch
                onClick={() => {
                  setShowSearchDropDown(true);
                  // setShowMobileMenu(false);
                }}
                className="cursor-pointer block lg:hidden justify-end text-xl"
              />
              <div
                onClick={() => setShowCart(prev => !prev)}
                className="relative bg-[#F0F0F0] dark:bg-[#2F2F2F] p-2 rounded-lg cursor-pointer"
              >
                <IoBagOutline className="text-2xl" />
                <div className="absolute top-1 text-xs right-1 bg-[#FF93B7] text-black flex items-center justify-center rounded-full h-[18px] w-[18px] p-1">
                  2
                </div>
                {showCart && (
                  <div ref={showCartRef} className="absolute top-14 -left-[250px] md:-left-80 z-[6000]">
                    <Cart setShowCart={setShowCart} />
                  </div>
                )}
              </div>
              {!loggedUser && (
                <a href="/Pages/Registration">
                  <button className="h-fit shrink-0 bg-black dark:bg-white dark:text-black text-white px-4 py-2 rounded-lg">
                    Join us
                  </button>
                </a>
              )}
              {loggedUser  && (
                <img
                onClick={() => setShowAcSideBar((prev) => !prev)}
                  className=" cursor-pointer w-8 h-8 rounded-full object-cover dark:border dark:border-gray-500"
                  src="https://images.pexels.com/photos/91227/pexels-photo-91227.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                  alt=""
                />
              )}
            </div>
          </div>
        </div>
      )}

      {/* <----------------------- when click on image on the right of nav -----------------------> */}
      <div ref={acSideBarRef} className={showAcSideBar ? "block" : "hidden"}>
        <AcMobileDropDown setLoggedUser={setLoggedUser} />
      </div>
      {/* <----------------------- when click on hamburger menu on the left of nav -----------------------> */}
      <div
      ref={showMobileMenuRef}
        className={
          showMobileMenu ? "absolute w-full top-[75px] left-0 z-10 " : "hidden"
        }
      >
        <MobileMenu author={author} />
      </div>
    </>
  );
};

export default Navbar;
